module.exports = __webpack_public_path__ + "static/img/coin.6d7a931.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/coin.png
// module id = 10
// module chunks = 1